
// tslint:disable

declare var global: any;

export function polyfill() {
  let local;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  if (!local.Symbol) {
    local.Symbol = function (this: void, name: string) {
      return `[[${name}_${Math.random().toFixed(8).slice(2)}]]`
    };
  }

  if (!local.Symbol.asyncIterator) {
    local.Symbol.asyncIterator = local.Symbol.for && local.Symbol.for('Symbol.asyncIterator') || '__@asyncIterator__';
  }
}
